<script setup>
import { computed, useTrackEvent } from '#imports';

const props = defineProps({
  article: {
    type: Object,
    required: true,
  },
});

const isArticleCardsType = computed(() => props.article.isArticleCardsType);
function trackEvent(eventType, name) {
  useTrackEvent(eventType, {
    props: {
      name,
    },
  });
}

const handleClick = () => {
  trackEvent('click', `Click on next article`);
};
</script>

<template>
  <div class="next-article">
    <div class="next-article__title content-container">Следующий материал</div>
    <ArticleHeaderCard
      :article="article"
      :is-article-cards-type="isArticleCardsType"
      class="next-article__head"
      is-next-article
    />
    <div v-if="article.lead" class="next-article__lead content-container">
      <ArticleLead :lead="article.lead" />
    </div>
    <div class="next-article__button-wrap content-container">
      <a
        v-if="article.isArticleExternalSourceType"
        :href="article.externalSource"
        class="next-article__button"
        target="_blank"
        @click="handleClick"
      >
        Смотреть полностью
      </a>
      <NuxtLink
        v-else
        :to="{
          name: 'articles-slug',
          params: { slug: article.slug.current },
        }"
        class="next-article__button"
        @click="handleClick"
        >Читать полностью</NuxtLink
      >
    </div>
    <span class="next-article__shadow"></span>
  </div>
</template>

<style lang="postcss" scoped>
.next-article {
  position: relative;
  z-index: 1;
  padding-bottom: 80px;

  &__head {
    border-radius: 24px 24px 0 0;
  }

  &__title {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 22px;
    color: rgba(var(--black-color--rgb), 40%);
  }

  &__lead {
    position: relative;
    z-index: 3;
    max-height: 194px;
    margin-top: -60px;
    padding-right: 360px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      z-index: 4;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 130px;
      background: linear-gradient(
        180deg,
        rgba(255, 246, 251, 0%) 0%,
        rgba(255, 246, 251, 90%) 49.48%,
        #fff6fb 100%
      );
    }
  }

  &__button-wrap {
    margin-top: -72px;
  }

  &__button {
    display: inline-block;
    position: relative;
    z-index: 5;
    padding: 5px 32px;
    text-align: center;
    font-size: 24px;
    line-height: 54px;
    font-weight: 700;
    color: rgba(var(--accent-color--rgb), 100%);
    background-color: #f2e6f1;
    border-radius: 12px;
    cursor: pointer;
    transition: var(--default-transition) color;

    &:hover {
      color: rgba(var(--accent-color--rgb), 60%);
    }
  }

  &__shadow {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 400px;
    background: linear-gradient(
      180deg,
      rgba(255, 246, 251, 0%) 0%,
      rgba(255, 246, 251, 92%) 40.1%,
      #fff6fb 100%
    );
  }

  @media (--small-vp) {
    padding-bottom: 40px;

    &__title {
      margin-bottom: 8px;
      padding-right: 6px;
      font-size: 14px;
      line-height: 20px;
    }

    &__head {
      border-radius: 16px 16px 0 0;
    }

    &__lead {
      margin-top: -48px;
      padding: 0 12px;
      max-height: 160px;
    }

    &__button-wrap {
      display: flex;
      margin-top: -46px;
    }

    &__button {
      width: 100%;
      margin: 0 auto;
      padding: 16px 75px;
      font-size: 20px;
      line-height: 24px;
    }

    &__shadow {
      height: 360px;
    }
  }
}
</style>
